/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_WebsiteInputs */

const en_directory_submit_website = /** @type {(inputs: Directory_Submit_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const zh_directory_submit_website = /** @type {(inputs: Directory_Submit_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网站`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Directory_Submit_WebsiteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_website = /** @type {((inputs?: Directory_Submit_WebsiteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_WebsiteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_website(inputs)
	return zh_directory_submit_website(inputs)
});
export { directory_submit_website as "directory.submit.website" }